<div>
    <div id="instance-details" [style.padding.px]="20">
        @if(instanceDetails$ | async; as d) {
        <div class="instance-details-item inline-block text-center">
            <div class="label">Nazwa instancji</div>
            <div>{{d.name}}</div>
        </div>
        <div class="instance-details-item inline-block text-center">
            <div class="label">Domyślna instancja</div>
            <div *rolePermission="'instance.toggles.edit'">
                <mat-slide-toggle [checked]="d.default">
                </mat-slide-toggle>
            </div>
        </div>
        <div class="instance-details-item inline-block inline-block text-center">
            <div class="label">Biling</div>
            <div *rolePermission="'instance.toggles.edit'">
                <mat-slide-toggle [checked]="d.billing">
                </mat-slide-toggle>
            </div>
        </div>
        }
    </div>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="tabChanged($event)">
        <mat-tab label="Klienci">
            <mat-table [dataSource]="clients" id="clients-table" class="mat-elevation-z8 selectable-table">
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
                    <mat-cell *matCellDef="let client">{{client.name}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="createDate">
                    <mat-header-cell *matHeaderCellDef>Date rejestracji</mat-header-cell>
                    <mat-cell *matCellDef="let client">{{client.createDate | date:'dd-MM-yyyy HH:mm'}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="active">
                    <mat-header-cell *matHeaderCellDef>Aktywny</mat-header-cell>
                    <mat-cell *matCellDef="let client"><span [outerHTML]="client.active | boolToImg"></span></mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="['name', 'createDate', 'active']; sticky: true"
                    class="table-header"></mat-header-row>
                <mat-row *matRowDef="let client; columns: ['name', 'createDate', 'active']"
                    (click)="selectClient(client)"></mat-row>
            </mat-table>
        </mat-tab>
        <mat-tab label="Kody zaproszenia">
            <button matButton="elevated" id="btn-open-add-invite-key-dialog"
                *rolePermission="'instance.inviteCodes.manage'"
                (click)="openAddInviteCodeDialog()">+</button>
            <mat-table [dataSource]="inviteCodes" class="mat-elevation-z8">
                <ng-container matColumnDef="code">
                    <mat-header-cell *matHeaderCellDef>Kod</mat-header-cell>
                    <mat-cell *matCellDef="let inviteCode">{{inviteCode.code}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                    <mat-header-cell *matHeaderCellDef>Wygenerowany</mat-header-cell>
                    <mat-cell *matCellDef="let inviteCode">{{inviteCode.createdAt | date:'dd-MM-yyy HH:mm' }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="used">
                    <mat-header-cell *matHeaderCellDef class="cell-center">Został użyty</mat-header-cell>
                    <mat-cell *matCellDef="let inviteCode" class="cell-center"><span
                            [outerHTML]="inviteCode.used | boolToImg"></span></mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="['code', 'createdAt', 'used']"></mat-header-row>
                <mat-row *matRowDef="let invingteCode; columns: ['code', 'createdAt', 'used']"></mat-row>
            </mat-table>
        </mat-tab>
    </mat-tab-group>
</div>